/**
 * Contain the Style for the Login View
 */

//ColorManager
import ColorManager from "./../managers/ColorManager";

export default {

    text: {
        marginBottom: 16
    },

    loginButton: {
        backgroundColor: ColorManager.primaryColor,
        color: ColorManager.text,
        marginTop: 16
    }
};



// WEBPACK FOOTER //
// ./src/app/styles/Logout.ts